import { render, staticRenderFns } from "./jidian.vue?vue&type=template&id=d7436138&scoped=true"
import script from "./jidian.vue?vue&type=script&lang=js"
export * from "./jidian.vue?vue&type=script&lang=js"
import style0 from "./jidian.vue?vue&type=style&index=0&id=d7436138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7436138",
  null
  
)

export default component.exports